// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kdh1","field":"styles_field__1U3Fy","fieldCol":"styles_fieldCol__1FbbS","diffCol":"styles_diffCol__6mbP6","diff":"styles_diff__3A7uu"};